import axios from "axios"
import { END_POINTS } from "./endpoints";

let setShowTimeoutModal = null;
let setIsAuthenticated = null;

export const registerSessionHandlers = (modalSetter, authSetter) => {
    setShowTimeoutModal = modalSetter;
    setIsAuthenticated = authSetter
};

const instance = axios.create({
    baseURL: process.env.REACT_APP_DEVELOP,
    headers: {
        'Access-Control-Allow-Origin': '*',
    }
})

instance.interceptors.request.use((config) => {
    if (config.url !== END_POINTS.login || config.url !== END_POINTS.verifyOtp) {
        const accessToken = localStorage.getItem('token')
        config.headers["Authorization"] = `Bearer ${accessToken}`
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

instance.interceptors.response.use((response) => {
    if ((response.config.url.includes('provider/verify-otp') || response.config.url.includes('provider/change-hospital')) && response.data.success) {
        localStorage.setItem('token', response?.data?.data?.token)
        if (setIsAuthenticated) {
            setIsAuthenticated(true)
        }
    }
    return response
}, (error) => {
    if (error.response && error.response.status === 401) {
        if (setShowTimeoutModal) {
            setShowTimeoutModal(true);
        } else {
            localStorage.clear();
            window.location.href = "/";
        }
    }
    return Promise.reject(error)
})

export const API = {
    post: async (endPoint, body={}) => {
        try {
            const response = await instance.post(endPoint, body)
            return response?.data
        } catch (error) {
            let errorMessage = '';
            let data = error?.response?.data ||{}
            switch (data.errorCode) {
                case 'BAD_REQUEST':
                    errorMessage = Object.values(data.errors).join(' | ');
                    break;
                case 'OTP_NOT_FOUND':
                    errorMessage = data.errors.error;
                    break;
                case 'USER_NOT_FOUND':
                    errorMessage = data.errors.error;
                    break;
                default:
                    errorMessage = data.message;
            }
            return {
                success: false,
                message: errorMessage,
                errorCode: data.errorCode,
                status: error?.response?.status,
            };
        }
    },
    get: async (endPoint) => {
        try {
            const response = await instance.get(endPoint)
            return response?.data
        } catch (error) {
            return {
                success: false,
                message: error?.response?.data?.message || error.message,
                status: error?.response?.status,
            };
        }
    },
    patch: async (endPoint, body) => {
        try {
            const response = await instance.patch(endPoint, body)
            return response?.data
        } catch (error) {
            const data = error?.response?.data || {};
            return {
                success: false,
                message: data.message || error.message,
                errorCode: data.errorCode,
                status: error?.response?.status,
            };
        }
    },
    put: async (endPoint, body) => {
        try {
            const response = await instance.put(endPoint, body)
            return response?.data
        } catch (error) {
            return error
        }
    },
    delete: async (endPoint) => {
        try {
            const response = await instance.delete(endPoint)
            return response?.data
        } catch (error) {
            return {
                success: false,
                message: error?.response?.data?.message || error.message,
                status: error?.response?.status,
            };
        }
    },
}